export type AgentApiScope =
    | 'projects:read'
    | 'projects:write'
    | 'files:read'
    | 'files:write'
    | 'customers:read'
    | 'plastics:read'
    | 'plastics:commercial:read'
    | 'metals:read'
    | 'resource-search:read'
    | 'quote-studio:read'
    | 'quote-studio:write';

export type AgentApiMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
export type AgentApiParityMode = 'api-only' | 'contract' | 'shared-logic';

export interface AgentApiEndpointDefinition {
    id: string;
    method: AgentApiMethod;
    path: string;
    requiredScope: AgentApiScope | null;
    contractVersion: number;
    logicId: string;
    logicVersion: number;
    parityMode: AgentApiParityMode;
    fixtureIds: string[];
}

export interface AgentApiResponseMeta {
    contractVersion: number;
    logicId: string;
    logicVersion: number;
    logicHash: string;
    buildSha: string;
    asOf: string;
    warnings: string[];
    dataCompleteness?: number;
}

export interface AgentApiResponse<T> {
    data: T;
    meta: AgentApiResponseMeta;
}

export interface AgentApiPage<T> {
    items: T[];
    nextCursor: string | null;
}

export interface AgentApiBuildInfo {
    service: 'agent-api';
    apiVersion: 'v1';
    buildSha: string;
    endpointsHash: string;
}

export const AGENT_API_CONTRACT_VERSION = 1;

/**
 * Browser-safe deterministic fingerprint. The nightly parity runner verifies behavior with
 * fixtures; this value makes deployed client/API version drift immediately visible.
 */
export function agentApiFingerprint(value: string): string {
    let hash = 0x811c9dc5;
    for (let index = 0; index < value.length; index++) {
        hash ^= value.charCodeAt(index);
        hash = Math.imul(hash, 0x01000193);
    }
    return (hash >>> 0).toString(16).padStart(8, '0');
}
